import { Languages } from "lucide-react";
import { useLocalization } from "@/context/localization-context";
import { localeLabels, localeShortLabels, type Locale } from "@/i18n/messages";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";

/** Language of the UI (English by default), remembered in the browser. */
export function LanguageSelect() {
  const { locale, setLocale, supportedLocales, t } = useLocalization();

  return (
    <Select value={locale} onValueChange={(value) => setLocale(value as Locale)}>
      <SelectTrigger
        aria-label={t("common.language")}
        title={t("common.language")}
        className="h-8 w-auto gap-1.5 border-0 bg-transparent px-2 text-xs font-semibold text-muted-foreground shadow-none hover:bg-muted hover:text-foreground"
      >
        <Languages className="h-4 w-4 shrink-0" />
        {localeShortLabels[locale]}
      </SelectTrigger>
      <SelectContent align="end">
        {supportedLocales.map((item) => (
          <SelectItem key={item} value={item}>
            {localeLabels[item]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
